import { StyledDrawer } from 'modules/Courses/Partials/AddCourseDrawer/Style/style'
import { getSingleRoleStudentDetails } from 'modules/Dashboard/actions'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import CustomSteps from './CustomSteps'

const StepperDrawer = ({ drawer, setDrawer, selectedStudent }) => {
  const params = useParams()
  const dispatch = useDispatch()
  const [completedStep, setCompletedStep] = useState()
  const [completStedepStatus, setCompletStedepStatus] = useState()

  const viewRoleData = useSelector(
    state => state?.dashboard?.dashboardDriveStudent
  )

  useEffect(() => {
    dispatch(
      getSingleRoleStudentDetails(params?.roleID, selectedStudent?.student?.id)
    )
  }, [params?.roleID])

  useEffect(() => {
    if (viewRoleData?.role?.driveRoleCandidateMap) {
      let data = viewRoleData?.role?.driveRoleCandidateMap[0]?.stage
      setCompletStedepStatus(
        viewRoleData?.role?.driveRoleCandidateMap[0]?.status
      )
      let index = viewRoleData?.role?.interviewWorkFlow?.rounds?.findIndex(
        x => x.name === data
      )
      setCompletedStep(index)
    }
  }, [viewRoleData])

  const stepsData1 = viewRoleData?.role?.interviewWorkFlow?.rounds?.map(
    (round, index) => {
      return {
        key: index,
        activeKey: index,
        roundNumber: `Round ${index + 1}`,
        roundName: round?.name,
      }
    }
  )
  const content = () => {
    return (
      <>
        {completStedepStatus != null && (
          <CustomSteps
            current={completedStep}
            currentStatus={completStedepStatus}
            steps={stepsData1}
            selectedStudent={selectedStudent}
          />
        )}
      </>
    )
  }

  return (
    <StyledDrawer
      width="600px"
      title={'Student Drive Status'}
      placement="right"
      closable={true}
      onClose={() => setDrawer(false)}
      visible={drawer}
      content={content()}
    />
  )
}

export default StepperDrawer
